module.exports = __webpack_public_path__ + "static/media/dyslexia.ec7edbdf.pdf";